<template>
<div class="ReservationTypeList">
</div>
</template>

<script>
export default {
    name: 'ReservationTypeList',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ReservationTypeList {
}
</style>
